import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../services/global';
import { BaseCrudComponent } from '../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';

import { Observable, from, of, concat } from 'rxjs';
import { mergeMap, catchError, timeout, retry, debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
    selector: 'app-agents',
  templateUrl: './agents.component.html',
  styleUrls: ['./agents.component.css']
})
export class AgentsComponent extends BaseCrudComponent {

    translations: any;
    listTypes: any;
    loadingRequired: any;

    constructor(
        srv: ApiService,
        modalService: NgbModal,
        storage: Storage,
        router: Router,
        private route: ActivatedRoute,
        public translate: TranslateService
    ) {
        super(srv, modalService, storage, router);

        this.read_url = 'Agent/All';
        this.create_url = '';
        this.update_url = 'Agent/Update';
        this.delete_url = '';
        this.search_fields = ['agentName', 'agentCode', 'superiorName', 'superiorCode'];
        
        this.listTypes = [];
        this.loadingRequired = false;

        this.reload.subscribe(val => {
            if (val) {
                super.clearData();
                this.getList();
            }
        });
    }

    ngOnInit() {
        this.translate.getTranslation(this.translate.currentLang)
            .subscribe((translations) => {
                this.translations = translations;
                super.ngOnInit();

                this.loadingRequired = true;
                this.getTypesData().subscribe(c => {
	                this.loadingRequired = false;
	                this.getList();
	            });
            });
    }

    openCreateModal(content: any) {
        this.c_obj = {};

        super.openCreateModal(content);
    }

    openUpdateModal(content: any, obj: any) {
    	obj['sup'] = null;

    	if( (obj['superiorCode'] != undefined) && (obj['superiorCode'] != null) ){
    		let tmp = this.rawdata.filter(r => r.agentCode == obj['superiorCode']);
    		if( tmp.length > 0 ){
    			obj['sup'] = tmp[0];
    		}
    	}

        super.openUpdateModal(content, obj);
    }

    validateCreateInfo(fields: any) {
        let mygroup: any = {};
        mygroup = new FormGroup({
            'name': new FormControl(fields.name, [Validators.required]),
            'code': new FormControl(fields.code, [Validators.required]),
            'typeId': new FormControl(fields.typeId, [Validators.required])
        });

        return mygroup.valid;
    }

    validateUpdateInfo(fields: any) {
        let mygroup: any = {};
        mygroup = new FormGroup({
            'agentName': new FormControl(fields.agentName, [Validators.required]),
            'agentCode': new FormControl(fields.agentCode, [Validators.required]),
            'typeId': new FormControl(fields.typeId, [Validators.required])
        });

        return mygroup.valid;
    }

    public createItem(content: any, form: any) {
        var validated = true;

        if (form == undefined) {
            form = {};
        }

        validated = this.validateCreateInfo(form);
        if (!validated) {
            Swal.fire(this.translations['msg_all_required'], '', 'error');
            return;
        }

        var to: any;
        to = {};
        to.fullName = form['fullName'];
        to.username = form['username'];
        to.password = form['password'];
        to.email = form['email'];
    

        if (form['sapCode'] != undefined) {
            to.sapCode = form['sapCode'];
        }

        var qst = this.create_url;
        this.isCreating = true;

        this.srv.postCall(qst, to).subscribe(x => {
            this.isCreating = false;
            if (x.status) {
                this.c_obj = {};
                this.getList();
                this.closeModal(content);
                Swal.fire(this.translations.created, '', 'success');
            }//end success
            else {
                //Swal.fire(this.translations[x.msg], '', 'error');
                Swal.fire(x.message, '', 'error');
            }
        });
    }

    public updateItem(content: any, form: any) {
        var validated = true;

        if (form == undefined) {
            form = {};
        }
        
        validated = this.validateUpdateInfo(form);
        if (!validated) {
            Swal.fire(this.translations['msg_all_required'], '', 'error');
            return;
        }

        var to: any;
        to = {};
        to.code = form.agentCode;
        to.typeId = form['typeId'];

        if( form['sup'] != null ){
            to['superior'] = form['sup']['agentCode'];
        }
        else{
        	to['superior'] = null;
        }
        
        var qst = this.update_url;
        this.isUpdating = true;

        this.srv.postCall(qst, to).subscribe(x => {
            this.isUpdating = false;
            if (x.status) {
                this.getList();
                this.closeModal(content);
                Swal.fire(this.translations['updated'], '', 'success');
            }//end success
            else {
                Swal.fire(x.message, '', 'error');
                //this.closeModal(content);
            }
        });
    }

    public getTypesData() {
        var par_url = 'SystemParameter/GetByName/AGT_TYPE';
        return this.srv.getCall(par_url).pipe(
            mergeMap(x => {
                let mydata: any = { status: false, message: '', data: [] };
                mydata = x;

                if (mydata.status == true) {
                	//console.log(mydata.data[0]);
                	if( Array.isArray(mydata.data) && (mydata.data.length > 0) ){
                		this.listTypes = mydata.data[0];
                	}

                    return of(true);
                }
                else {
                    return of(false);
                }
            }),
            //timeout(MAX_TIME),
            catchError(data => of(false))
        );
    }

}
